








import StudentFormInformation from '@/views/index/components/StudentFormInformation.vue'
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'studentRegister',
  components: {
    StudentFormInformation
  }
})
export default class extends Vue {}
